import { get, post } from "../utils/api/apiCaller";
import { ENDPOINTS } from "../utils/api/endpoints";
import type { ApiResponse } from "../utils/api/apiClient";

export const getPrecon = (projectId: string): Promise<ApiResponse> =>
  get(ENDPOINTS.PRECON.DETAIL(projectId));

export const savePrecon = (
  projectId: string,
  data: unknown,
): Promise<ApiResponse> => post(ENDPOINTS.PRECON.SAVE(projectId), data);

export const submitPrecon = (projectId: string): Promise<ApiResponse> =>
  post(ENDPOINTS.PRECON.SUBMIT(projectId));

export const approvePrecon = (
  projectId: string,
  data: unknown,
): Promise<ApiResponse> => post(ENDPOINTS.PRECON.APPROVE(projectId), data);

export const getGcChecklist = (projectId: string): Promise<ApiResponse> =>
  get(ENDPOINTS.GC_CHECKLIST.GET(projectId));

export const submitGcChecklist = (
  projectId: string,
  data: unknown,
  publish = false,
): Promise<ApiResponse> =>
  post(ENDPOINTS.GC_CHECKLIST.SUBMIT(projectId, publish), data);
